/* eslint-disable no-param-reassign */
import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from 'react-omnitech-api'
import HorizontalProductList from '../horizontal-product-list'
import ProductCard from '../product-card'
import useCustomerRankSettings from '../../hook/use-customer-rank-settings'
import useStyles from './recommendation-products-style'

const RecommendationProductsView = (props) => {
  const {
    ListHeaderComponent,
    onAfterInit,
    onBreakpoint,
    onClickTrackEvent,
    onNextLoad,
    onPageChange,
    pagination,
    items,
    siblings,
    siblingsLoading,
  } = props
  const styles = useStyles()
  const { t } = useTranslation()
  const {
    loyaltyInformation,
  } = useUser()
  const { default: defaultRank } = useCustomerRankSettings()
  const currentRank = _.get(loyaltyInformation, 'currentCustomerRank.code', defaultRank)

  const renderProduct = ({ item, index }) => {
    const siblingsProductCodes = _.get(item, 'siblingsProductCodes', [])
    const thisSiblings = _.filter(siblings, (sibling) => (
      _.includes(siblingsProductCodes, _.get(sibling, 'product.code', '////'))
    ))
    const thisSiblingsLoading = !_.isEmpty(siblingsProductCodes)
      && _.isEmpty(thisSiblings)
      && siblingsLoading
    const haveSiblings = !_.isEmpty(thisSiblings)
    const priceSuffix = haveSiblings && t('screens.product.price.up')
    const lowestSellPriceSibling = _.reduce(thisSiblings, (result, sibling) => {
      if (
        _.toNumber(_.get(result, 'sellPrice', 0))
        > _.toNumber(_.get(sibling, 'sellPrice', 0))
      ) {
        result = sibling
      }
      return result
    }, _.first(thisSiblings))
    const displaySellPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, 'sellPrice')
      : _.get(item, 'sellPrice')
    const displayOriginalPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, 'originalPrice')
      : _.get(item, 'originalPrice')
    const displayMemberPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, `meta.memberPrice.${currentRank}`)
      : _.get(item, 'memberPrice')
    return (
      <ProductCard
        {...item}
        sellPrice={displaySellPrice}
        originalPrice={displayOriginalPrice}
        memberPrice={displayMemberPrice}
        priceSuffix={priceSuffix}
        priceLoading={thisSiblingsLoading}
        onClickTrackEvent={onClickTrackEvent}
        index={index + 1}
      />
    )
  }
  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerComponent}>
          {ListHeaderComponent}
        </div>
      </div>
      <HorizontalProductList
        data={items}
        renderItem={renderProduct}
        pagination={pagination}
        onAfterInit={onAfterInit}
        onBreakpoint={onBreakpoint}
        onEndReached={onNextLoad}
        onSlideChange={onPageChange}
      />
    </>
  )
}

export default RecommendationProductsView
